import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'cam-andon-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="se">
      <div class="se-baslik">
        <div class="se-baslik-ikon" style="background:linear-gradient(135deg,#cf1322,#ff4d4f)">🚨</div>
        <span>Duruş / Yardım</span>
      </div>
      <div class="se-form">
        <div class="form-grup">
          <label>Duruş Sebebi <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <nz-select [ngModel]="p()?.durusSebebi" (ngModelChange)="guncelle('durusSebebi', $event)"
              nzPlaceHolder="Sebep seçin..." nzAllowClear nzShowSearch style="width:100%">
              <nz-option nzValue="Makine Arızası" nzLabel="Makine Arızası" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#ff4d4f"></span> Makine Arızası</span></nz-option>
              <nz-option nzValue="Malzeme Bekleme" nzLabel="Malzeme Bekleme" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#fa8c16"></span> Malzeme Bekleme</span></nz-option>
              <nz-option nzValue="Kalite Problemi" nzLabel="Kalite Problemi" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#faad14"></span> Kalite Problemi</span></nz-option>
              <nz-option nzValue="Personel Yetersiz" nzLabel="Personel Yetersiz" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#722ed1"></span> Personel Yetersiz</span></nz-option>
              <nz-option nzValue="Enerji Kesintisi" nzLabel="Enerji Kesintisi" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#13c2c2"></span> Enerji Kesintisi</span></nz-option>
              <nz-option nzValue="Diğer" nzLabel="Diğer" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#8c8c8c"></span> Diğer</span></nz-option>
            </nz-select>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup" style="flex:0 0 140px">
            <label>Duruş Süresi (dk)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.durusSuresi || null" (ngModelChange)="guncelle('durusSuresi', $event)"
                [nzMin]="0" [nzStep]="5" nzPlaceHolder="Dakika" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:1">
            <label>Bildiren</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off"
                [ngModel]="p()?.bildiren || ''" (ngModelChange)="guncelle('bildiren', $event)"
                placeholder="Bildiren kişi..."/>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Çözüm / Açıklama</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off"
              [ngModel]="p()?.cozum || ''" (ngModelChange)="guncelle('cozum', $event)"
              placeholder="Yapılan müdahale veya çözüm açıklaması..." cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4"></textarea>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrl: './cam-edit.styles.less',
})
export class AndonEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) { params.ek[alan] = deger; this.parametreler.set({ ...params }); }
  }
}
